module.exports = __webpack_public_path__ + "img/free-user-illustration.2a6b3c34.png";